import { render, staticRenderFns } from "./CompletedAttach.vue?vue&type=template&id=6c3c0639&"
import script from "./CompletedAttach.vue?vue&type=script&lang=js&"
export * from "./CompletedAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports